import PropTypes from 'prop-types'
import { H2 } from '../ui'

export const SettingsSection = ({ title, description, children, className = '' }) => (
  <div className={`bg-dark-secondary rounded-lg border border-dark-border p-6 ${className}`}>
    {(title || description) && (
      <div className="mb-6">
        {title && <H2 className="mb-2">{title}</H2>}
        {description && <p className="text-gray-400 text-sm">{description}</p>}
      </div>
    )}
    {children}
  </div>
)

SettingsSection.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
}

export default SettingsSection
